import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ReceiptPage() {
  const { t } = useTranslation();
  const { state } = useLocation();
  const navigate = useNavigate();

  const receipt = state?.receipt || {
    plan: 'Premium Mensuel',
    amount: '2.99',
    currency: 'USD',
    date: new Date().toLocaleDateString('fr-FR'),
    orderId: 'N/A',
    validUntil: new Date(Date.now() + 30*24*3600*1000).toLocaleDateString('fr-FR'),
  };

  const handlePrint = () => window.print();

  return (
    <div style={{ minHeight:'100vh', background:'radial-gradient(ellipse 80% 60% at 50% -10%,#2d1f7a44,transparent),var(--bg)', display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
      <div style={{ width:'100%', maxWidth:520 }}>
        {/* Header succes */}
        <div style={{ textAlign:'center', marginBottom:28 }}>
          <div style={{ width:72, height:72, borderRadius:'50%', background:'linear-gradient(135deg,#6af7b8,#00cc88)', margin:'0 auto 16px', display:'flex', alignItems:'center', justifyContent:'center', fontSize:36, boxShadow:'0 8px 32px #6af7b840' }}>
            ✓
          </div>
          <h1 style={{ fontFamily:'Syne,sans-serif', fontSize:28, fontWeight:800, color:'var(--text)', marginBottom:8 }}>{t('payment_success')}</h1>
          <p style={{ color:'var(--text2)', fontSize:15 }}>{t('welcome_premium')}</p>
        </div>

        {/* Recu */}
        <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:20, overflow:'hidden', boxShadow:'0 20px 60px #00000040' }} id="receipt-content">
          {/* En-tete recu */}
          <div style={{ background:'linear-gradient(135deg,#7c6af7,#f7c26a)', padding:'28px 32px' }}>
            <div style={{ fontFamily:'Syne,sans-serif', fontSize:22, fontWeight:800, color:'#fff', marginBottom:4 }}>BudgetFlow</div>
            <div style={{ color:'#ffffff99', fontSize:14 }}>{t('receipt_title')}</div>
          </div>

          {/* Montant principal */}
          <div style={{ textAlign:'center', padding:'32px 32px 24px', borderBottom:'1px solid var(--border)' }}>
            <div style={{ fontSize:13, color:'var(--text2)', marginBottom:8 }}>{t('receipt_amount')}</div>
            <div style={{ fontFamily:'Syne,sans-serif', fontSize:48, fontWeight:800, color:'var(--accent)', marginBottom:4 }}>
              {receipt.amount}<span style={{ fontSize:20, color:'var(--text2)', fontWeight:400 }}> {receipt.currency}</span>
            </div>
            <div style={{ display:'inline-block', background:'#6af7b820', border:'1px solid #6af7b840', borderRadius:20, padding:'4px 16px', fontSize:13, color:'var(--accent3)', fontWeight:600 }}>
              ⭐ {receipt.plan}
            </div>
          </div>

          {/* Details */}
          <div style={{ padding:'24px 32px' }}>
            {[
              { label: t('receipt_date'),        value: receipt.date },
              { label: t('receipt_id'),          value: receipt.orderId },
              { label: t('receipt_valid_until'), value: receipt.validUntil },
              { label: 'Statut',                 value: '✓ Confirme', color:'var(--accent3)' },
            ].map(row => (
              <div key={row.label} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 0', borderBottom:'1px solid var(--border)' }}>
                <span style={{ fontSize:14, color:'var(--text2)' }}>{row.label}</span>
                <span style={{ fontSize:14, fontWeight:600, color: row.color || 'var(--text)' }}>{row.value}</span>
              </div>
            ))}
          </div>

          {/* Note */}
          <div style={{ padding:'16px 32px 28px' }}>
            <div style={{ background:'var(--surface2)', borderRadius:12, padding:'14px 16px', fontSize:13, color:'var(--text2)', lineHeight:1.6 }}>
              Un email de confirmation a ete envoye avec ce recu. Conservez votre reference de commande pour tout litige.
            </div>
          </div>
        </div>

        {/* Boutons */}
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginTop:20 }}>
          <button onClick={handlePrint} style={{ padding:14, background:'var(--surface)', border:'1px solid var(--border)', borderRadius:12, color:'var(--text)', fontFamily:'Syne,sans-serif', fontWeight:600, fontSize:14 }}>
            🖨️ {t('receipt_download')}
          </button>
          <button onClick={() => navigate('/dashboard')} style={{ padding:14, background:'var(--accent)', border:'none', borderRadius:12, color:'#fff', fontFamily:'Syne,sans-serif', fontWeight:700, fontSize:14 }}>
            {t('receipt_back')} →
          </button>
        </div>
      </div>
    </div>
  );
}